
const DEFAULT_NAME = 'Other';
const NAME_TRANSLATE: Record<string, string> = {
    'Macintosh': 'macOS',
    'Trident': 'IE',
}
export const parseUserAgent = (userAgent: string) => {
    const browserRegex = /(?:Chrome|Safari|Firefox|Edge|IE|Trident|Opera|curl)/;
    const osRegex = /(?:Windows|Macintosh|iPhone|iPad|Android|Linux)/;

    const browserMatch = userAgent.match(browserRegex);
    const osMatch = userAgent.match(osRegex);

    let browser = browserMatch ? browserMatch[0] : DEFAULT_NAME;
    let os = osMatch ? osMatch[0] : DEFAULT_NAME;
    if (NAME_TRANSLATE[browser]) {
        browser = NAME_TRANSLATE[browser];
    }
    if (NAME_TRANSLATE[os]) {
        os = NAME_TRANSLATE[os];
    }

    return { browser, os };
}
